import { useMutation, useQueryClient } from "@tanstack/react-query";

import instance from "@/lib/axios";
import { useOrganizationStore } from "@/stores/useOrganizationStore";
import type { Notification } from "@/types/notification";

import { notificationKeys } from "./keys";

export function useMarkNotificationRead() {
  const orgSlug = useOrganizationStore((s) => s.orgSlug);
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: number): Promise<Notification> => {
      const response = await instance.post<Notification>(
        `/api/${orgSlug}/notifications/${id}/read/`,
      );
      return response.data;
    },
    onSuccess: () => {
      // A single row belongs to exactly one area, but the caller doesn't know
      // which — refresh every area's badge rather than guessing.
      queryClient.invalidateQueries({ queryKey: notificationKeys.lists() });
      queryClient.invalidateQueries({
        queryKey: notificationKeys.unreadCounts(),
      });
    },
    meta: { errorMessage: "Couldn't mark notification as read." },
  });
}

export default useMarkNotificationRead;
